import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { prop } from 'ramda';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import SelectField from 'Shared/form/SelectField';
import SubmitButton from 'Shared/form/SubmitButton';
import { TypeaheadField } from 'Shared/form/TypeaheadField';
import useFetchContentGroups from '../../hooks/useFetchContentGroups';

const CreateAssociationFormArea = ({ onClose }) => {
    const { handleSubmit, values } = useFormikContext();
    const [resourceInputValue, setResourceInputValue] = useState('');
    const { data: contentResources = [], isFetching } = useFetchContentGroups(values.resourceType?.value, {
        name: resourceInputValue,
        limit: 50,
    });

    return (
        <form onSubmit={handleSubmit}>
            <Modal.Body>
                <SelectField
                    fieldName="resourceType"
                    label="Select a resource to associate"
                    options={[
                        { value: 'drug', label: 'Medication' },
                        { value: 'disease', label: 'Therapeutic Category' },
                    ]}
                    required
                />

                {values.resourceType && (
                    <TypeaheadField
                        fieldName="resourceUuid"
                        label="Select a resource"
                        options={contentResources}
                        getOptionLabel={prop('name')}
                        getOptionValue={prop('uuid')}
                        isLoading={isFetching}
                        required
                        onInputChange={setResourceInputValue}
                    />
                )}
            </Modal.Body>

            <Modal.Footer>
                <FormButtonGroup>
                    <Button variant="outline-secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <SubmitButton>Create Association</SubmitButton>
                </FormButtonGroup>
            </Modal.Footer>
        </form>
    );
};

CreateAssociationFormArea.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default CreateAssociationFormArea;
